import React, { useEffect, useState } from "react";
import ShowToast from "components/ShowToast";

import './PSWalletSettlement.css'
import { useSession } from "hooks/useSession";
import AddAccountModal from "./components/AddPSBankAccount";
import TransferAmountModal from "./components/MakePaymentModel";
import UploadDocumentModal from "./components/UploadBankDocumentModel";
import { fetchWrapper } from "utils/apiFetch";
import { AEPSReceiptModa } from "Settings/Reports/AEPSReceipt";
import PayoutReceiptModal from "Settings/Reports/PayoutReceipt";
const PSWalletSettlement = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedBeneId, setSelectedBeneId] = useState("123");
  const [showReceipt, setShowReceipt] = useState(false);
  const [receiptData, setReceiptData] = useState(null);


  const { userid } = useSession();
  useEffect(() => {
    fetchSettlementList();
  }, []);


  const fetchSettlementList = async () => {


    setLoading(true);
    try {
      const res = await fetchWrapper(
        `https://pro.mokshiq.in/get_list_of_beneficiary?userid=${userid}`
      );
      const data = res;
      setList(data?.data || []);
    } catch {
      ShowToast("Failed to load data", "danger");
    } finally {
      setLoading(false);
    }
  };
  const fetchPayoutReceipt = async (txnId) => {
    try {
      const res = await fetchWrapper(
        `https://pro.mokshiq.in/show_payout_receipt?id=${txnId}`
      );

      if (res?.data) {
        setReceiptData(res.data);
        setShowReceipt(true);
      } else {
        ShowToast("Failed to load receipt", "danger");
      }
    } catch {
      ShowToast("Receipt fetch failed", "danger");
    }
  };


  return (
    <main>
      <div className="container-fluid ui-section">
        <div className="row m-1">
          <div className="col-10 ">
            <h4 className="main-title">Main Wallet Settlement</h4>
            <ul className="app-line-breadcrumbs mb-3">
              <li>
                <a className="f-s-14 f-w-500" href="#">
                  <span>
                    <i className="ph-duotone ph-briefcase-metal f-s-16"></i>{" "}
                    Services
                  </span>
                </a>
              </li>
              <li className="active">
                <a className="f-s-14 f-w-500" href="#">
                  Main Wallet Settlement
                </a>
              </li>
            </ul>
          </div>
          <div className="col-2"> <button
            className="add-btn"
            onClick={() => setShowAddModal(true)}
          >
            Add Account
          </button></div>
        </div>
        <div className="wallet-page">


          {loading ? (
            <div className="loader">Loading...</div>
          ) : list.length === 0 ? (
            <div className="empty-state">No settlement accounts added</div>
          ) : (
            <div className="wallet-grid">
              {list.map((item) => (
                <div className="wallet-card" key={item.beneid}>
                  <div className="card-header">
                    <h5>{item.bankname}</h5>
                    <span className={`status ${item.verified === "1" ? "active" : "pending"}`}>
                      {item.verified === "1" ? "Active" : "Pending"}
                    </span>
                  </div>

                  <div className="card-body">
                    <div className="info-row">
                      <span>Account Holder</span>
                      <b>{item.name}</b>
                    </div>
                    <div className="info-row">
                      <span>Account No</span>
                      <b>{item.account}</b>
                    </div>
                    <div className="info-row">
                      <span>IFSC</span>
                      <b>{item.ifsc}</b>
                    </div>
                  </div>

                  <div className="card-footer">
                    {item.status === "2" ? (
                      <button
                        className="btn secondary"
                        onClick={() => {
                          setSelectedBeneId(item.beneid);
                          setShowUploadModal(true);
                        }}
                      >
                        Upload Documents
                      </button>
                    ) : (
                      <button
                        className="btn primary"
                        onClick={() => {
                          setSelectedRow(item);
                          setShowTransferModal(true);
                        }}
                      >
                        Settle Now
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}


          {/* Add Account Modal */}
          <AddAccountModal
            show={showAddModal}
            onClose={() => setShowAddModal(false)}
            onSuccess={fetchSettlementList}
          />

          {/* Transfer Amount Modal */}
          {selectedRow && showTransferModal && (

            <TransferAmountModal
              key={selectedRow.beneid}
              show={showTransferModal}
              onClose={() => {
                debugger;
                setShowTransferModal(false);
                setSelectedRow(null);
              }}
              userData={selectedRow}
              onSuccess={(txnId) => {


                setShowTransferModal(false);   // 👈 CLOSE MODAL
                setSelectedRow(null);          // 👈 CLEAR STATE
                fetchSettlementList();
                fetchPayoutReceipt(txnId);       // 👈 REFRESH LIST
              }}

            />
          )}
          <UploadDocumentModal
            show={showUploadModal}
            onClose={() => setShowUploadModal(false)}
            beneid={selectedBeneId}
          />
          <PayoutReceiptModal
            isOpen={showReceipt}
            receiptData={receiptData}
            onClose={() => {
              setShowReceipt(false);
              setReceiptData(null);
              document.body.classList.remove("modal-open");
            }}
          />



        </div>
      </div>
    </main>
  );
};

export default PSWalletSettlement;
